import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import LinearProgress from '@material-ui/core/LinearProgress';

import 'noto-sans-sc/all.css';
import './index.css';
import App from './App';
import './locales/i18n';
import store, { persistor } from './store';
import ConditionalPersist from './store/conditionalPersist';

ConditionalPersist();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <React.Suspense fallback={null}>
        <PersistGate loading={<LinearProgress />} persistor={persistor}>
          <App />
        </PersistGate>
      </React.Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
